import React, {useEffect, useState} from 'react';
import CircularLoader from "../Common/CircularLoader";
import EmptyListPlaceholder from "../Common/EmptyListPlaceholder";
import ChefForPartyService from '../../services/ChefForPartyService';
import CookList from './ChefForPartyCookList';
import { useRefresh } from 'react-admin';

interface InputProps {
    partyId: number
}

const chefForPartyService = new ChefForPartyService();

const ChefForPartCooksTab = (props: InputProps) => {

    let [subData, setSubData] = useState<any>(null);
    let [isLoading, setIsLoading] = useState<boolean>();
    const [partyData, setPartyData] = useState<any>(null);
    const raRefresh = useRefresh();

    const refreshData = React.useCallback((partyId: number) => {
        setIsLoading(true)
        chefForPartyService.fetchOneChefForParty(partyId)
            .then((data: any) => {
                setSubData(data?.data?.cooks);
                setPartyData(data?.data)
                setIsLoading(false);
                raRefresh();
            })
            .catch((err) => {
                setIsLoading(false);
            })
    }, [raRefresh])

    useEffect(() => {
        refreshData(props.partyId);
    }, [props.partyId, refreshData])

    return (
        <div>
            {
                isLoading ?
                    <CircularLoader/>
                    :
                    <div>
                        {subData &&
                            Array.isArray(subData) &&
                            (
                                subData.length>0 ?
                                    <CookList data={subData} party={partyData} refresh={() => {refreshData(Number(props.partyId))}} />
                                    :
                                    <EmptyListPlaceholder
                                        message='No Cooks Assgin Yet'
                                    />
                            )
                        }
                    </div>
            }
        </div>
    );
};

export default ChefForPartCooksTab;
